import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buildTeaser } from './build-teaser';
import { Button } from '@/components';
import { useOpportunityToPpt } from '../../hooks';
import { useFeature } from '@/features/users/hooks';
import { useNotifications } from '@/features/notifications';
import { FEATURES } from '@/config';

type GenerateTeaserData = {
  opportunity: any;
};

export const GenerateTeaser = ({ opportunity }: GenerateTeaserData) => {
  const { t } = useTranslation(['opportunities']);
  const [isGenerating, setIsGenerating] = useState(false);

  const userCanGenerate = useFeature(FEATURES.GENERATE_TEASER);
  const { add } = useNotifications();

  const { pptData } = useOpportunityToPpt(opportunity);

  const handleGenerateTeaser = async () => {
    if (!pptData || isGenerating) return;
    setIsGenerating(true);

    try {
      await buildTeaser(pptData);
    } catch (error) {
      console.error('Error generating teaser:', error);
      add({
        id: new Date().toString(),
        title: t('ERROR'),
        description: t('Error generating teaser. Please try again later.'),
      });
    } finally {
      setIsGenerating(false);
    }
  };

  if (!userCanGenerate) return null;

  return (
    <Button
      size="sm"
      color="link"
      icon="download"
      onClick={handleGenerateTeaser}
      className="text-primary-700"
      disabled={isGenerating || !pptData}
    >
      {isGenerating ? t('Loading') : t('Generate Teaser')}
    </Button>
  );
};
